import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button } from "../../../../components/simple";

import OptionTooltip from "../../../../components/complex/Tooltips/Options";
import SVG from "../../../../components/SVG";

import styles from "./team-row.module.scss";

function TeamRow({ profile, onRemove, currentUser, onChangeRole }) {
  const [optionsPopper, setOptionsPopper] = useState(null);

  const toggleOptions = (evt, id = null) => {
    evt.stopPropagation();
    evt.preventDefault();

    setOptionsPopper(id && optionsPopper !== id ? id : null);
  };

  const optionTarget = `audience-options-${profile.id}`;
  const tooltipOptions = {
    placement: "top",
    isOpen: optionsPopper === profile.id,
    target: optionTarget,
    toggle: evt => toggleOptions(evt),
    trigger: "legacy",
    fade: true,
    flip: false
  };

  return (
    <tr role="row" className={styles.row}>
      <td className={styles.name}>
        {// eslint-disable-next-line no-nested-ternary
        profile.isActive
          ? profile.name
            ? profile.name
            : profile.email
          : `${profile.email} - Pending`}
      </td>
      <td className={styles.permission}>
        <Button
          className={`btn-transparent ${styles["permission-select"]}`}
          type="button"
          disabled={
            profile.id === currentUser?.id ||
            currentUser?.role === "user" ||
            currentUser?.role === undefined
          }
          onClick={evt => toggleOptions(evt, profile.id)}
          id={optionTarget}
        >
          {profile.role}
        </Button>
        <OptionTooltip
          tooltipOptions={tooltipOptions}
          actions={[
            {
              label: "Admin",
              callback: evt => {
                evt.stopPropagation();
                setOptionsPopper(null);
                onChangeRole(profile.id, "admin");
              }
            },
            {
              label: "User",
              callback: evt => {
                evt.stopPropagation();
                setOptionsPopper(null);
                onChangeRole(profile.id, "user");
              }
            }
          ]}
        />
      </td>
      {currentUser?.role === "admin" || currentUser?.role === "gdr admin" ? (
        <td className={styles.remove}>
          <button
            type="button"
            onClick={() => {
              onRemove(profile.id);
            }}
          >
            <SVG.Trash width={16} height={22} />
          </button>
        </td>
      ) : null}
    </tr>
  );
}

TeamRow.propTypes = {
  onChangeRole: PropTypes.func,
  onRemove: PropTypes.func.isRequired,
  profile: PropTypes.shape({
    name: PropTypes.string,
    role: PropTypes.string,
    id: PropTypes.string,
    isActive: PropTypes.bool,
    email: PropTypes.string
  }).isRequired,
  currentUser: PropTypes.shape({
    id: PropTypes.string,
    role: PropTypes.string
  })
};

TeamRow.defaultProps = {
  onChangeRole: () => {},
  currentUser: { role: "user", id: "" }
};

export default TeamRow;
